import { render, staticRenderFns } from "./LoginInstrutor.vue?vue&type=template&id=5ead0ec4&scoped=true"
import script from "./LoginInstrutor.vue?vue&type=script&lang=js"
export * from "./LoginInstrutor.vue?vue&type=script&lang=js"
import style0 from "./LoginInstrutor.vue?vue&type=style&index=0&id=5ead0ec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ead0ec4",
  null
  
)

export default component.exports